import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IAlertOptions } from 'src/app/shared/interfaces/ialert-options';
import { AlertType } from '../../enums/alert-type.enum';

@Component({
    selector: 'app-alert-popup',
    templateUrl: './alert-popup.component.html',
    styleUrls: ['./alert-popup.component.scss'],
})
export class AlertPopupComponent implements OnInit {
    icon: string = '';

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: IAlertOptions,
        private snackBarRef: MatSnackBarRef<AlertPopupComponent>
    ) {}

    ngOnInit(): void {
        if (this.data.type === AlertType.info) {
            this.icon = 'check';
        } else if (this.data.type === AlertType.warning) {
            this.icon = 'error';
        } else {
            this.icon = 'close';
        }
    }

    dismissSnackbar() {
        this.snackBarRef.dismiss();
    }
}
